module.exports = {"410106001":"济源路街道","410106002":"中心路街道","410106003":"新安路街道","410106004":"工业路街道","410106005":"矿山街道","410106100":"峡窝镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410106.json
// module id = 1636
// module chunks = 0